module.exports = __webpack_public_path__ + "static/media/headerProfile.27fc7a08.svg";